module.exports = __webpack_public_path__ + "img/unlocked.22528701.png";